export default {
    HOME_PAGE: '/',
    DESTINATIONS_PAGE: '/destinations',
    SHARED_ROUTE: '/destinations/:regionSlug/:destinationSlug/:slug',
    DESTINATION_PAGE: '/destinations/:regionSlug/:slug',
    REGION_PAGE: '/destinations/:regionSlug',
    HOTELS_PAGE: '/hotels',
    HOTEL_PAGE: '/destinations/:regionSlug/:destinationSlug/:hotelSlug',
    HOTEL_WITH_DESTINATION_PARENT_PAGE: '/destinations/:regionSlug/:parentDestinationSlug/:destinationSlug/:hotelSlug',
    HOTEL_ROOM_PAGE: '/destinations/:regionSlug/:destinationSlug/:hotelSlug/rooms/:roomSlug',
    HOTEL_ROOM_WITH_DESTINATION_PARENT_PAGE: '/destinations/:regionSlug/:parentDestinationSlug/:destinationSlug/:hotelSlug/rooms/:roomSlug',
    CLUSTER_PAGE: '/destinations/:regionSlug/:destinationSlug/:hotelSlug/cluster/:roomSlug',
    HOTEL_CLUSTER_WITH_DESTINATION_PARENT_PAGE: '/destinations/:regionSlug/:parentDestinationSlug/:destinationSlug/:hotelSlug/cluster/:roomSlug',
    OFFERS_PAGE: '/offers',
    PRIVACY_POLICY_PAGE: '/privacy-policy',
    QUOTE_PAGE: '/get-quote/:type/:slug',
    QUOTE_THANK_YOU_PAGE: '/get-quote/thank-you',
    FAQ_PAGE: '/faq',
    CONTACT_US_PAGE: '/contact-us',
    CONTACT_US_THANK_YOU_PAGE: '/contact-us/thank-you',
    ABOUT_US_PAGE: '/about-us',
};
